import React from 'react';
import { Button } from '@/components/ui/button.tsx';
import { RefreshCcw } from 'lucide-react';
import { formatTitle } from '@/helpers/helperFunctions.ts';

interface HeaderSectionProps {
  websiteName: string;
  currentCategoryIdx: number;
  totalCategories: number;
  currentCategoryName: string;
  progressPercent: number;
  hasUnsavedChanges: boolean;
  onSave: () => void;
  onRefresh: () => void;
}

const HeaderSection: React.FC<HeaderSectionProps> = ({
  websiteName,
  currentCategoryIdx,
  totalCategories,
  currentCategoryName,
  progressPercent,
  hasUnsavedChanges,
  onSave,
  onRefresh
}) => {
  return (
    <div className="bg-gradient-to-r from-kay-main to-kay px-8 py-4 shadow">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
        <div>
          <div className="text-kay-black font-bold text-xl leading-tight">
            {formatTitle(websiteName)} Data Collection
          </div>
          <div className="text-kay-black text-sm">
            Step {currentCategoryIdx + 1} of {totalCategories}: {currentCategoryName}
          </div>
        </div>
        <div className="flex items-center gap-4 mt-2 md:mt-0">
          <Button
            className="bg-blue-600 text-white hover:bg-blue-700 px-3 py-1 text-sm"
            onClick={onSave}
            size="sm"
            type="button"
          >
            Save Progress
          </Button>
          <Button
            className='invisible'
            onClick={onRefresh}
            size='sm'
            type="button"
            variant='secondary'
          >
            {hasUnsavedChanges ? (
              <RefreshCcw className="text-red-600" size={14} />
            ) : (
              <RefreshCcw size={14} />
            )}
          </Button>
          <div className="flex flex-col items-end min-w-[180px]">
            <span className="text-kay-black text-xs font-medium mb-1">
              {progressPercent}% Complete
              {hasUnsavedChanges && <span className="text-red-600 ml-1">*</span>}
            </span>
            <div className="w-full h-2 bg-white rounded">
              <div 
                className="h-2 bg-green-500 rounded transition-all" 
                style={{ width: `${progressPercent}%` }} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;